import angular from 'angular';

angular
  .module('commonServices')
  .service('insights', [
    'resourceFactorySvc',
    '$q',
    'authService',
    '$http',
    'appUrls',
    'checkSecurity',
    insights,
  ]);

function insights(resourceFactorySvc, $q, authService, $http, appUrls, checkSecurity) {
  var cache = this;
  var lock = null;
  cache.ready = false;
  cache.insights = {};

  var loadInsights = function() {
    var deferred = $q.defer();
    var userId = authService.getUserId();
    const segmentsPromise = $http.get(appUrls.api + `/api/user/segments/${userId}`);

    Promise.all([segmentsPromise]).then(
      ([{ data: segments }]) => {
        cache.insights = {
          ...cache.insights,
          segments,
        };
        deferred.resolve(true);
      },
      error => {
        deferred.reject(error);
      },
    );
    return deferred.promise;
  };

  var ready = function() {
    if (lock != null) return lock.promise;
    lock = $q.defer();

    if (!cache.ready) {
      loadInsights().then(
        function() {
          lock.resolve(cache);
          cache.ready = true;
        },
        function(error) {
          cache.ready = false;
          if (lock != null) lock.reject(error);
          lock = null;
        },
      );
    } else {
      lock.resolve(cache);
    }
    return lock.promise;
  };
  ready();

  var destroy = function() {
    cache = {
      ready: false,
    };
    lock = null;
  };

  authService.addOnLogOut(function() {
    destroy();
  });

  return {
    ready: ready,
    get: function() {
      return cache.insights;
    },
  };
}
